module.exports = "<h1 id=\"加载中--loading-directive\">加载中  loading-directive</h1>\n";